import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'
export const StyledTurnIns = styled.div`
  --padding-content: 3rem;
  --padding-content-mobile: 2rem;

  .dropdown:focus,
  .dropdown:focus-visible,
  .dropdown:hover {
    box-shadow: none;
  }
  .dropdown-item.active,
  .dropdown-item:focus-visible,
  .dropdown-item:hover {
    outline: 0;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    color: #fff;
    /* border-bottom: 1px solid ${({ theme }) => theme.colors.InfinitiOnlyColor}; */
  }
  .dropdown-menu {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);
  }

  form {
    /* padding: 20px var(--padding-content);
    border-radius: 3px;
    box-shadow: 0px -1px 2px rgb(0 0 0 / 15%), 2px 2px 2px rgb(0 0 0 / 25%);
    margin: 5px 0 30px 0;
    display: block;
    background-color: white; */

    > p:first-child {
      text-align: end;
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 0;
    }
  }

  button {
    margin-left: 0;
    padding: 5px 20px;
  }

  .error-label {
    min-height: 1.8rem;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 1.2rem !important;
    margin-bottom: 0;
    margin-top: 10px !important;
    font-weight: bold;
  }

  .alert {
    max-width: 100% !important;
  }

  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-1,
  .col-md-6,
  .col-md-5,
  .col-md-1,
  .col-sm-4,
  .col-lg-12 {
    padding: 0;
  }

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  .text-divider {
    padding: 0;
    margin-top: 15px;
    text-transform: uppercase;

    h2 {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
    }

    :first-child {
      margin-top: 0;
    }
  }

  .right-field,
  .left-field {
    label {
      font-weight: 600;
    }

    .col-lg-6 {
      padding: 0;
    }
  }

  .left-field {
    padding-right: calc(var(--padding-content) / 2);
  }

  .right-field {
    padding-left: calc(var(--padding-content) / 2);
  }

  .dropdown-container {
    height: 30px;
  }

  .actual-mileage-warning {
    min-height: 1.8rem;
    line-height: 1.8rem;
    font-size: 15px;
    color: red;
    margin-bottom: 0;
  }

  .odometer-warning {
    margin-bottom: 10px;
    p:before {
      content: '! ';
    }

    .odometer-warning-label {
      font-size: 15px;
      color: red;
      text-align: end;
      margin: 0;
    }

    .form-check {
      text-align: end;

      input {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }

      label {
        cursor: pointer;
        font-weight: normal;
      }
    }
  }
`

export const StyledTurnInTitle = styled.div`
  color: ${({ theme }) => theme.colors.defaultTextColor};

  span {
    font-weight: 600;
  }
  a {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
  }
`
export const StyledTurnIn = styled.div`
  padding: 2rem 3rem 3rem;
  border-radius: 3px;
  box-shadow: 0px -1px 2px rgb(0 0 0 / 15%), 2px 2px 2px rgb(0 0 0 / 25%);
  margin: 5px 0 30px 0;
  display: block;
  background-color: white;
  font-size: 14px;

  > p:first-child {
    text-align: end;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: -6px;
  }

  span {
    line-height: 30px;
  }

  .close {
    height: 100%;

    span {
      line-height: 0;
    }
  }

  svg {
    fill: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    vertical-align: text-bottom;
    margin-right: 8px;
  }

  .ack-checkbox {
    & > label {
      text-transform: uppercase;
      margin-bottom: 5px;
    }

    .checkbox-form {
      margin-bottom: 30px;
    }
  }

  .upper-receipt {
    padding-bottom: 0 !important;
  }

  .nosign-container {
    display: flex;
    flex-wrap: wrap;
    margin: 80px 0px 20px;

    .nosign-dropdown {
      display: flex;
      flex-direction: column;

      .error-label {
        margin-left: 14px;
      }
    }
    .dropdown-container {
      margin-left: 8px;
      min-width: 300px;
    }

    @media (min-width: ${gridBreakPoints.sm}) {
    }

    @media (min-width: ${gridBreakPoints.lg}) {
      width: 1000px;

      .dropdown-container {
        margin-left: 14px;
        max-width: 300px;
      }
    }
    @media (min-width: ${gridBreakPoints.xl}) {
      width: 1100px;
    }

    label {
      margin-bottom: 6px;
    }
  }

  .payment-dropdown {
    display: flex;
    flex-direction: column;
    transform: translateY(24px);
  }

  > .row {
    padding-bottom: 10px;

    .left-field,
    .right-field {
      padding: 0;
    }
  }

  .price-span {
    float: right;
    transform: translateY(-4px);
  }
  .price-total {
    font-weight: bold;
    font-size: 16px;
  }

  .row-parent + .row-parent {
    margin-top: 4rem;
  }
  .row-child + .row-parent {
    margin-top: 1rem;
  }
  .row-child {
    margin-top: 1rem;
    padding-left: 1.5rem;
  }
  .btn-row {
    display: block;
    text-align: end;
    margin-top: 20px;
    margin-bottom: 15px;
  }
  .row-form-group {
    flex-direction: column;
  }
  .acknowledgements_cb > label > div > a,
  #termsLink {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    :hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
    }
  }
  .btn-link {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    :hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
    }
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
  .custom-control-label::after {
    border: #adb5bd solid 1px;
  }
`

export const StyledLabelRequired = styled.span`
  display: flex;
  ::after {
    content: '*';
    color: ${({ theme }) => theme.colors.primary};
  }
`
